import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCart } from 'b2b-apps/shop/cart/redux/cart/actionCreators';
import { getCart } from 'b2b-apps/shop/cart/redux/cart/selectors';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { CartType } from 'b2b-common/core/cart/api/CartTypes';

type UseCartReturnType = RemoteRecord<CartType>;

const useCart = (): UseCartReturnType => {
  const dispatch = useDispatch();
  const cart = useSelector(getCart);

  useEffect(
    (): void => {
      dispatch(fetchCart());
    },
    [dispatch],
  );

  return cart;
};

export type { UseCartReturnType };
export { useCart };
